<template>
    <div class="contactInfo">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-container>
                <div class="MedicalText" style="width: 100%">
                    <el-row v-for="(item, index) in data" :key="index">
                        <el-col :xs="24" :md="13" class="companyImg">
                          <template>
                            <baidu-map
                              class="bm-view"
                              scroll-wheel-zoom
                              :center="{ lng: item.data.contentUs.longitude, lat: item.data.contentUs.latitude }"
                              :zoom="+item.data.contentUs.baiduMapZoom"
                              :ak="item.data.contentUs.baiduMapAK"
                              style="width: 100%; height: 350px"
                            >
                              <bm-marker
                                @click="openMark"
                                :position="{ lng: item.data.contentUs.longitude, lat: item.data.contentUs.latitude }"
                                :dragging="true">
                                <bm-info-window
                                  :position="{ lng: item.data.contentUs.longitude, lat: item.data.contentUs.latitude }"
                                  :show="isMarker"
                                  style="width: 200px"
                                  @close="closeMark"
                                >
                                  <el-col :span="24" style="font-size: 16px; font-weight: bold; color: #f00">{{item.data.contentUs.title}}</el-col>
                                  <el-col :span="24">{{item.data.contentUs.addressLabel}}: {{item.data.contentUs.address}}</el-col>
                                  <el-col :span="24">{{item.data.contentUs.telLabel}}: {{item.data.contentUs.tel}}</el-col>
                                  <el-col :span="24"><i class="iconfont icon-ditu"></i> {{item.data.contentUs.longitude + '，' + item.data.contentUs.latitude}}</el-col>
                                </bm-info-window>
                              </bm-marker>
                            </baidu-map>
                          </template>
                        </el-col>
                        <el-col :xs="24" :md="11" class="MedicalTextActive">
                            <h3>{{item.data.contentUs.title}}</h3>
                            <ul class="contactMain">
                                <li>
                                    <i class="iconfont icon-ditu"></i>
                                    {{item.data.contentUs.addressLabel}}: {{item.data.contentUs.address}}
                                </li>
                                <li>
                                    <i class="iconfont icon-email-s"></i>
                                    {{item.data.contentUs.emailLabel}}: {{item.data.contentUs.email}}
                                </li>
                                <li>
                                    <i class="iconfont icon-bangongdianhua"></i>
                                    {{item.data.contentUs.telLabel}}: {{item.data.contentUs.tel}}
                                </li>
                                <li>
                                    <i class="iconfont icon-chuanzhen"></i>
                                    {{item.data.contentUs.faxLabel}}: {{item.data.contentUs.fax}}
                                </li>
                                <li>
                                    <i class="iconfont icon-bianhao"></i>
                                    {{item.data.contentUs.zipCodeLabel}}: {{item.data.contentUs.zipCode}}
                                </li>
                            </ul>
                            <div>
                                <el-button size="small" plain  @click="handleClick(i)"  v-for="(i, index2) in item.data.buttons" :key="index2">→ {{i.text}}</el-button>
                            </div>
                            <div class="WX" v-if="item.data.qrcodeUrl">
                                <img :src="item.data.qrcodeUrl" :alt="item.imgAlt">
                                <p>{{item.data.qrcodeText}}</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-container>
        </div>
    </div>
</template>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'
export default {
  components: {
    BaiduMap,
    BmInfoWindow
  },
  props: {
    val: {}
  },
  data(){
      return{
        data: [],
        isMarker: true,
      }
  },
  created() {
    this.data = this.val.attaches;
  },
  methods: {
    openMark() {
      this.isMarker = !this.isMarker;
    },
    closeMark() {
      this.isMarker = false;
    },
    handleClick(row) {
        window.open(row.linkUrl, '_self');
    }
  },
  watch: {
    val(val) {
      this.data = this.val.attaches;
    }
  }
}
</script>
<style lang="less" scoped>
.contactInfo{
    .MedicalText{
        border-radius: 4px;
        overflow: hidden;
        background: #f7f7f7;
        position: relative;
        height: auto;
        .el-col{
            height: auto;

        }
        .MedicalTextActive{
            padding:20px 20px 0;
            box-sizing: border-box;
            text-align: left;
            line-height: 2;
            overflow: hidden;
            .el-button{
                margin-bottom: 10px;
            }
            .contactMain{
                padding: 0;
                margin: 0;
                li{
                    i{
                        color: #d11a2e;
                    }
                }
            }
            h3{
                color: #d11a2e;
                font-weight: normal;
                margin: 0;
            }

        }
        .companyImg{
            position: relative;
            span{
                position:absolute;
                right: 0;
                top:50%;
                margin-top: -10px;
                display: block;
                width: 0;
                height: 0;
                border:20px solid transparent;
                border-right-color:#f7f7f7;
            }
            img{
                width:100%;
                display: block;
            }
        }
        .WX{
            position:absolute;
            right:20px;
            bottom: 20px;
            text-align: center;
            font-size: 14px;
            img{
                width: 65px;
                height: 65px;
                margin: 0 auto;
            }
            p{
                margin: 0;
            }
        }

    }
    @media only screen and (min-width: 768px){
        .MedicalText{
            height: 350px;
            .el-col{
                height: 100%;
            }
            .companyImg {
                height: 100%;
                img{
                    height: 100%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch23.vue